import { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{ zIndex: 2147483647 }}
      toastOptions={{
        className: '',
        duration: 4000,
        style: {
          background: '#FFFFFF',
          color: '#000000',
          border: '1px solid #DEE3E9',
          borderRadius: '12px',
          padding: '16px 20px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
          fontSize: '14px',
          fontWeight: '500',
        },

        // Success — cyan accent from btn-gradient start
        success: {
          duration: 4000,
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #0cddff',
            boxShadow: '0 4px 16px rgba(68, 206, 237, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#0cddff',
            secondary: '#FFFFFF',
          },
        },

        // Error — red/pink accent from btn-gradient2 end
        error: {
          duration: 5000,
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #00d4ff',
            boxShadow: '0 4px 16px rgba(221, 35, 69, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#00d4ff',
            secondary: '#FFFFFF',
          },
        },

        // Loading — purple accent from btn-gradient2 start
        loading: {
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #020024',
            boxShadow: '0 4px 16px rgba(112, 43, 115, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#020024',
            secondary: '#FFFFFF',
          },
        },

        // Blank/info — pink accent from btn-gradient end
        blank: {
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #5f7fdb',
            boxShadow: '0 4px 16px rgba(246, 150, 255, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
        },
      }}
    />
  );
}
